import { getManagerOpportunitiesRoute } from "@verivest/shared-components";
import React from "react";
import { useHistory } from "react-router";
import { InvestorPortalEmptyStatus } from "../../../InvestorPortalEmptyStatus";

export const WLManagerNoInvestments = () => {
  const history = useHistory();

  return (
    <InvestorPortalEmptyStatus
      imgSrc={
        "/images/investor-portal/empty-status-images/white-label/investments.svg"
      }
      target={"investments"}
      buttonLabel={"View opportunities"}
      buttonOnClick={() => history.push(getManagerOpportunitiesRoute())}
      subTitle={"Once you make your first investment, it will appear here."}
    />
  );
};
